import React from 'react';
import { useStore } from 'zustand';

import type { ExtranetHotelPack } from 'app/typings/core/extranet/hotel/packs';

import { inventoryStore } from '../../../../InventoryStore';
import { usePackExperiences } from '../../../../hooks';
import { CollapseTable } from '../../../Table/CollapseTable/CollapseTable';

import { PackBookingsRow } from './rows/PackBookingsRow';
import { PackMaxBookingRow } from './rows/PackMaxBookingRow';
import { PackStatusRow } from './rows/PackStatusRow';
import { PackStockRow } from './rows/PackStockRow';
import { RoomPackagePriceDiscountRow } from './rows/RoomPackagePriceDiscountRow';

type Props = {
  pack: ExtranetHotelPack;
};

const DayPackTableItemComponent: React.FC<Props> = ({ pack }) => {
  const isEditMode = useStore(inventoryStore, (state) => state.isEditMode);
  const packName = pack.nameForHotel || '';

  const { packExperiences, packExperiencesNames } = usePackExperiences(pack);

  const images = [packExperiences[0]?.coverPicture].filter(
    (img): img is NonNullable<typeof img> => !!img
  );

  return (
    <CollapseTable
      key={`pack-${pack.id}`}
      images={images}
      title={packName}
      keyPanel={`pack-${pack.id}`}
      hasInfo
      info={
        packExperiencesNames.length > 0
          ? packExperiencesNames.join(' + ')
          : undefined
      }
    >
      <PackStatusRow packId={pack.id} />
      <PackStockRow packId={pack.id} />
      <PackBookingsRow packId={pack.id} />
      {isEditMode && <PackMaxBookingRow packId={pack.id} />}
      <RoomPackagePriceDiscountRow packId={pack.id} />
    </CollapseTable>
  );
};

export const DayPackTableItem = React.memo(DayPackTableItemComponent);
